import apiClient from '~/config/apiClient';

export const getWeeklyPlan = (project_id: string, params?: any) => {
  return apiClient.get(`/projects/${project_id}/mobile-dashboard/weekly-plan`, {
    params,
  });
};

export const getMobileProjectDashboard = (project_id: string, params: any) => {
  return apiClient.get(`/projects/${project_id}/mobile-dashboard`, {
    params,
  });
};
